<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="main-wrapper-content Publish">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/circle' }">社区</el-breadcrumb-item>
          <el-breadcrumb-item>发布作业</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="circle-center_tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first">
            <div class="list-img-box">
              <div class="list-flex">
                <div class="less-than-four">
                  <!-- <div class="less-than-four-img">
                    <img src="@/assets/circle/img05.jpg">
                  </div>
                  <div class="play-btn">
                    <img src="@/assets/circle/img66.png" />
                  </div> -->
                </div>
              </div>
              <div class="line"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <h2 class="center-h2">选择课程</h2>
      <div class="course-list">
        <ul>
          <li v-for="(item,index) in courseData" :key="index" @click="Publish(item.id)">
            <img :src="item.thumb">
          </li>
        </ul>
      </div>
      <h2 class="center-h2">作业列表</h2>
      <div class="course-center" v-for="(item, i) in  publishList" :key="i" >
        <div class="course-center_div">
          <img :src="item.images" alt="">
        </div>
        <div style="width:200px; text-align:left;">{{item.title}}</div>
        <div class="teaching-time">{{item.create_time}}</div>
        <div class="teacher-name">{{ item.teacher_name }}</div>
        <div class="is-submit-box">
          <span class="not-submit"></span>
        </div>
        <div class="operation">
          <span class="not-submit" v-if="item.is_submit != 1" @click="toHomeWork(item.chapter_id)">交作业</span>
          <span class="not-submit" v-else>已提交</span>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'Publish',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        activeName: 'first',
        publishList: [],
        courseData: []
      }
    },
    created() {
      this.myCourse()
    },
    methods: {
      myCourse() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/myCourse', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            type: "2",
            limit: 100
          }
        }).then(res => {
          this.courseData = res.data.data.data //正式课数据
        }).catch(err => {
          console.log(err)
        })
      },
      Publish(id) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/homework/list', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            course_id: id
          }
        }).then(res => {
          this.publishList = res.data.data
        }).catch(err => {
          console.log(err)
        })
        // // 查找此课程自己所在班级
        // this.$axios({
        //   method: 'post', // 请求格式
        //   url: '/api/user/courseClasses', // 请求路径
        //   headers: { // 设置请求头
        //     token: this.$cookieStore.getCookie('token')
        //   },
        //   data: {
        //     course_id: id,
        //     type: 1
        //   }
        // }).then(res => {

        // }).catch(err => {
        //   console.log(err)
        // })
      },
      handleClick(tab, event) {
        console.log(tab, event)
      },
      toHomeWork(id) {
        this.$router.push({
          path: "/Publishneiru",
          query: {
            id: id
          }
        })
      }
    }
  }
</script>
<style scoped>
  /deep/ .Publish .circle-center_tabs .el-tabs__header {
    padding: 11px !important;
  }

  .course-list ul::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动条里面小方块 */
  .course-list ul::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  /* 滚动条里面轨道 */
  .course-list ul::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .course-list {
    margin: 20px 0 30px 0;
  }

  .course-list ul {
    overflow: auto;
    display: -webkit-box;
    padding: 10px 0;
  }

  .course-list ul li {
    width: 185px;
    height: 125px;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 20px;
  }

  .course-list ul li img {
    height: 100%;
  }

  .Publish {
    padding: 0px;
    margin: 0px;
    width: 780px;
    margin: 0 auto;
    min-height: 750px;
  }

  .content_top {
    margin: 30px 0 10px 0;
    padding: 20px 0;
  }

  .course-center {
    display: flex;
    align-items: center;
    margin: 0 0px;
    padding: 25px 0;
    border-bottom: 1px solid #ccc;
  }

  .center-h2 {
    margin-top: 20px;
    width: 87px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 28px;
  }

  .course-center_div {
    margin-right: 10px;

  }

  .course-center_div img {
    width: 80px;
    height: 80px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 6px;
  }

  .course-center_div div {
    margin-left: 8px;
    width: 160px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #383640;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    word-break: break-word;
    overflow: hidden;
    margin-top: 18px;
  }

  .teaching-time {
    width: 150px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #383640;
    line-height: 20px;
  }

  .teacher-name {
    width: 115px;
  }

  .is-submit-box {
    width: 115px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    line-height: 20px;
  }

  .is-submit-box>.not-submit {
    cursor: pointer;
    color: #fa6400;
  }

  .operation {
    width: 100px;
    float: right;
  }

  .operation .not-submit {
    display: block;
    width: 80px;
    height: 32px;
    background: linear-gradient(270deg, #25d878, #FABE00);
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 500;
    color: #fff;
    line-height: 32px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Publishlist.vue